module.exports = __webpack_public_path__ + "img/balance.de82df7e.svg";